import { useTheme } from "@emotion/react";
import React from "react";
import { Link } from "react-router-dom-v5-compat";
import tinycolor from "tinycolor2";

type Props = {
  children?: React.ReactNode;
  className?: string;
  stripe?: React.ReactNode;
  onClick?: () => void;
  gap?: string;
  href?: string;
};

export const Tile: React.FunctionComponent<Props> = (props) => {
  return (
    <TileWrapper {...props}>
      {props.stripe}
      <div
        css={{
          gap: props.gap,
          minWidth: "0",
          padding: "0.5rem 0.75rem",
          display: "flex",
          flex: "1 0 0",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        {props.children}
      </div>
    </TileWrapper>
  );
};

const TileWrapper: React.FC<Props> = (props) => {
  const theme = useTheme();

  const styles = {
    borderRadius: theme.smallBorderRadius,
    background: "white",
    display: "flex",
    flexDirection: "row",
    justifyItems: "stretch",
    overflow: "hidden",
    maxWidth: "100%",
    height: "100%",
    border: `1px solid ${tinycolor("#000000").setAlpha(0.1)}`,
    textAlign: "left",
    padding: 0,
    "&:hover": {
      textDecoration: "none",
    },
  } as const;

  if (props.href) {
    return (
      <Link to={props.href} onClick={props.onClick} css={styles} className={props.className}>
        {props.children}
      </Link>
    );
  }

  if (props.onClick) {
    return (
      <button onClick={props.onClick} css={styles} className={props.className}>
        {props.children}
      </button>
    );
  }

  return (
    <div css={styles} className={props.className}>
      {props.children}
    </div>
  );
};
